import React, { FC, useContext } from 'react';

import { Button, Modal, ConditionView } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { TattooSearchContext } from '../../context/TattooSearchContext';

import { TattooDetailsContent } from './TattooDetailsContent';

import './TattooSearchDetailsModal.scss';

export const TattooSearchDetailsModal: FC = React.memo(() => {
  const { tattooDetailsData, isDetailsLoading, handleModalClose } = useContext(TattooSearchContext);

  return (
    <Modal
      size="lg"
      open={!!tattooDetailsData}
      onCancel={handleModalClose}
      title="Детальна інформація"
      footer={<Button onClick={handleModalClose}>Закрити</Button>}
      classNames={{
        content: 'tattoo-details__modal-content',
        body: 'tattoo-details__modal-body',
        footer: 'tattoo-details__modal-footer',
        header: 'tattoo-details__modal-header',
      }}
    >
      <ConditionView
        if={isDetailsLoading}
        else={tattooDetailsData && <TattooDetailsContent tattooData={tattooDetailsData} />}
      >
        <Loader centered />
      </ConditionView>
    </Modal>
  );
});
